import {
  Stack,
  StackProps,
  Typography,
  TypographyProps
} from "@mui/material";
import {
  styled
} from "@mui/material/styles";

export const TopicCardSignatureStack = styled(Stack)<StackProps>(({ theme }) => ({
  alignItems:"center",
  display:"flex",
  flexDirection:"row",
  gap:theme.spacing(2)
}));


export const InfoTypography = styled(Typography)<TypographyProps & {color?:string}>(({ theme, color }) => ({
  color: color || theme.customColors.textWidget,
  fontWeight: "400",
  lineHeight: "1rem",
  fontSize: "0.875rem",

  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
    lineHeight: "14px"
  }
}));
